import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { UserPermissionGQL } from "../../../generated/graphql";
import { ProjectService } from "./project.service";

export enum UserPermissionEnum {

  ADMIN_PROJECT_PROJECT_DETAILS_READ = 211002 ,
  ADMIN_PROJECT_GALLERY_READ = 211102,
  ADMIN_PROJECT_UNIT_SETUP_READ = 211202,
  ADMIN_PROJECT_CAR_PARK_SETUP_READ = 212602,
  ADMIN_PROJECT_LAYOUT_IMAGES_READ = 211302,
  ADMIN_PROJECT_SALES_CHART_SETUP_READ = 211402,
  ADMIN_PROJECT_SALES_DOCUMENTS_READ = 211502,
  ADMIN_PROJECT_UNIT_ALLOCATION_READ = 211602,
  ADMIN_PROJECT_SITE_PROGRESS_READ = 211702,
  ADMIN_PROJECT_ROLE_AUTHORIZATION_READ =211802,
  ADMIN_PROJECT_STANDARD_LETTER_READ = 211902,
  ADMIN_PROJECT_TEAM_ASSIGNMENT_READ = 212002,
  ADMIN_PROJECT_SALES_PACKAGES_READ = 212102,
  ADMIN_PROJECT_DISCOUNT_READ = 212202,
  ADMIN_PROJECT_PANEL_END_FINANCIER_READ = 212302,
  ADMIN_PROJECT_PANEL_SOLICITOR_READ = 212402,
  ADMIN_PROJECT_POLICY_SETTING_READ = 212502,
  ADMIN__READ = 20002
}

@Injectable()
export class ACLService {
  currentUserSubject = new BehaviorSubject<any>({});
  constructor(
    private userPermissionGQL: UserPermissionGQL,
    projectService: ProjectService
  ) {
    projectService.Current$.subscribe((id) => {
      this.getData(id);
    });
  }

  getData(projectId: string) {
    this.currentUserSubject.next(null);
    if (projectId) {
      this.userPermissionGQL
        .fetch({ projectId: projectId })
        .subscribe((result) => {
          if (result.errors) {
            this.currentUserSubject.next(null);
          } else {
            this.currentUserSubject.next(result.data);
          }
        });
    }
  }
}
